import React from 'react';
import { Card } from 'antd';

const ProfileSidebar = () => (
    <Card title="账户设置" bordered={false} className="content-menu">
        @TODO:
        更换 Google 账户
        绑定 Telegram
        删除帐号
    </Card>
);

export default ProfileSidebar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/parts/ProfileSidebar.tsx